import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid } from 'react-bootstrap';

import Pagination from '../../../components/Pagination';
import Table from './components/Table';
import ExportForm from './components/Form';
import CustomizeModal from '../../../components/Modal/Customize';

import { getPaymentExportConfig, getPaymentExportList, makePaymentExport } from '../../../services/endpoints/payments';

const Export = () => {
  const history = useHistory();

  const [data, setData] = useState({});
  const [config, setConfig] = useState({});
  const [isLoading, setIsLoading] = useState({ page: true, table: false });
  const [open, setOpen] = useState(false);
  const [includeColumns, setInclude] = useState([]);

  const toggle = () => setOpen(!open);

  const fetchList = async (showLoader = false, showTableLoader = false) => {
    showLoader && setIsLoading((prevState) => ({ ...prevState, page: true }));
    showTableLoader && setIsLoading((prevState) => ({ ...prevState, table: true }));

    try {
      const response = await getPaymentExportList();
      if (response.success) {
        setData(response?.data);
      }
      showLoader && setIsLoading((prevState) => ({ ...prevState, page: false }));
      showTableLoader && setIsLoading((prevState) => ({ ...prevState, table: false }));
    } catch (error) {
      showLoader && setIsLoading((prevState) => ({ ...prevState, page: false }));
      showTableLoader && setIsLoading((prevState) => ({ ...prevState, table: false }));
      return error;
    }
  };

  const fetchConfig = async () => {
    try {
      const response = await getPaymentExportConfig();
      if (response.success) {
        setConfig(response?.data);
        setInclude(response?.data?.export_columns.filter((col) => col.is_selected));
      }
    } catch (error) {
      return error;
    }
  };

  const getAllData = async () => {
    setIsLoading((prevState) => ({ ...prevState, page: true }));

    try {
      await Promise.all([fetchList(), fetchConfig()]);
      setIsLoading((prevState) => ({ ...prevState, page: false }));
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, page: false }));
    }
  };

  const onMakeExport = async (values, actions) => {
    const parsedStatuses = config?.statuses?.filter((el) => values?.include_statuses?.includes(el.title)).map((el) => +el.id);
    const findMode = config?.modes?.find((item) => item.title === values.include_modes);
    const payload = {
      from_date: values.date.startDate,
      to_date: values.date.endDate,
      include_statuses: config?.statuses?.length === values.include_statuses.length ? -1 : parsedStatuses,
      include_users: values.include_users.length === 0 ? -1 : values.include_users.map((item) => item.id),
      include_methods: config?.methods?.length === values.include_methods.length ? -1 : values.include_methods,
      include_modes: findMode ? findMode.id : -1,
      include_columns: includeColumns?.map((item) => item.id),
    };

    try {
      await makePaymentExport(payload);
      await fetchList(false, true);
      actions.setSuccess(true);
    } catch (error) {
      actions.setSuccess(false);
      actions.setErrors(error?.data?.error_message || 'Something went wrong');
    }
  };

  useEffect(() => {
    getAllData();
    document.title = 'Payments export';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (config?.access?.export_list === false) {
    history.push('/payments');
  }

  return (
    <Grid fluid>
      <CustomizeModal
        open={open}
        toggle={toggle}
        className="customize__modal"
        items={config?.export_columns}
        setInclude={setInclude}
        include={includeColumns}
      />

      {isLoading.page ? (
        <div className="modal-loader" />
      ) : (
        <>
          <ExportForm config={config} toggle={toggle} onSubmit={onMakeExport} />
          {isLoading.table ? (
            <div className="table-loader" />
          ) : (
            <>
              <Table items={data?.tasks} config={config} />
              <Pagination
                pages={data?.pagination?.pages}
                currentPage={data?.pagination?.current_page}
                itemsCount={data?.pagination?.total_count}
                pageSize={data?.pagination?.page_size}
                pagesLimit={data?.pagination?.pages < 10 ? data?.pagination?.pages : 10}
              />
            </>
          )}
        </>
      )}
    </Grid>
  );
};

export default Export;
